module.exports = __webpack_public_path__ + "img/system-img.fa83eb48.png";